import DamagedPartModal from '@/common/components/adjusterReport/damagedPoints/DamagedPartModal';
import DamagedPointsDescriptionModal from '@/common/components/adjusterReport/damagedPoints/damagedPointsDescriptionModal/DamagedPointsDescriptionModal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import { VehicleSideQueryResponseType } from '@/common/queries/selections/VehicleSide/VehicleSideQuery.type';
import { VehicleSideQueryOptions } from '@/common/queries/selections/VehicleSide/VehicleSideQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { UserTypeProps } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantType';
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const DamagedPointsComponent = ({
  header,
  buttons,
  pointsList,
  userType,
  needSelectedPoints,
}: {
  header?: React.ReactNode;
  buttons?: React.ReactNode;
  pointsList?: React.ReactNode;
} & UserTypeProps & { needSelectedPoints: boolean }) => {
  const { damagedId, id } = useParams();

  const [sideName, setSideName] = useState<VehicleSideQueryResponseType | null>(
    null,
  );
  const { setSelectedSideName } = useDamagedPoints();
  const { data: fileVehicleType, isSuccess } = useQuery(
    getVehicleTypeQueryOption({ damaged_pk: damagedId, file_pk: id! }),
  );

  const openVehiclePartModal = (side: VehicleSideQueryResponseType) => {
    setSideName(side);
    setSelectedSideName(side?.name?.fa_const);
  };
  const { data } = useQuery(
    VehicleSideQueryOptions({
      enabled: isSuccess,
      vehicleType: fileVehicleType?.id!,
    }),
  );

  return (
    <>
      <Flex pt={24} justifyContent="space-between" alignItems="center">
        <TitleDescription>نقاط آسیب‌دیده</TitleDescription>
        <DamagedPointsDescriptionModal userType={userType} />
      </Flex>
      {header}
      <Box mt={32}>
        <Box
          display="flex"
          gap={8}
          overflowX="auto"
          flexWrap="nowrap"
          width="100%"
          css={{
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
          pb={2}
        >
          {data?.map((side) => (
            <Box
              key={side?.id}
              bg="purple-6"
              minW={70}
              minH={24}
              borderRadius={8}
              onClick={() => openVehiclePartModal(side)}
            >
              <Typography color="black-1" textStyle="b2" textAlign="center">
                {side?.name?.fa_const}
              </Typography>
            </Box>
          ))}
          {sideName && (
            <DamagedPartModal
              needSelectedPoints={needSelectedPoints}
              open={true}
              closeModal={() => setSideName(null)}
              selectedPart={sideName}
              userType={userType}
            />
          )}
        </Box>
      </Box>
      {pointsList}
      {buttons}
    </>
  );
};

export default DamagedPointsComponent;
